import { FC, useEffect } from 'react';
import { VStack, Button } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { CreateCardDeckTraitData } from '@olagg/db-types';
import OlaggForm from '../../../components/Forms/OlaggForm';
import OlaggFormInput from '../../../components/Forms/OlaggFormInput';
import { formTraitSchema } from '@olagg/validation-schemas/cardDecks.schemas';
import { yupResolver } from '@hookform/resolvers/yup';

interface TraitFormProps {
  onSubmit: (dataForm: CreateCardDeckTraitData) => void;
  trait?: CreateCardDeckTraitData;
}

const TraitForm: FC<TraitFormProps> = ({ onSubmit, trait }) => {
  const useFormMethods = useForm<CreateCardDeckTraitData>({
    resolver: yupResolver(formTraitSchema),
    mode: 'onChange',
  });

  useEffect(() => {
    if (trait) {
      useFormMethods.reset(trait);
    }
  }, [trait]);

  return (
    <OlaggForm
      useFormMethods={useFormMethods}
      onSubmit={onSubmit}
      style={{
        width: '100%'
      }}
    >
      <VStack spacing={4} maxW='600px' margin='0 auto'>
        <OlaggFormInput
          label='Nombre'
          controlName='name'
          required={true}
        />

        <OlaggFormInput
          label='Nombre (inglés)'
          controlName='nameEn'
        />

        <OlaggFormInput
          label='Nombre (portugués)'
          controlName='namePt'
        />

        <OlaggFormInput
          label='Layer'
          controlName='layer'
          description='Posicion de la imagen (0=fondo)'
          required={true}
        />

        <Button
          variant={'filledGradient'}
          type="submit"
          w={'full'}
          style={{
            marginTop: '30px'
          }}
        >
          Guardar
        </Button>
      </VStack>
    </OlaggForm>
  );
};

export default TraitForm; 
